function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M5.979.326A.898.898 0 016.674 0h6.229c.27 0 .526.12.695.326l1.512 1.846h2.242c1.226 0 2.224.97 2.224 2.168v8.261c0 1.197-.995 2.168-2.223 2.168H2.222C.995 14.77 0 13.798 0 12.601V4.34c0-1.197.998-2.168 2.225-2.168h2.241L5.98.326zM7.1 1.738L5.59 3.583a.898.898 0 01-.695.327h-2.67a.44.44 0 00-.444.43v8.261c0 .237.198.43.442.43h15.131a.438.438 0 00.444-.43V4.34a.44.44 0 00-.445-.43h-2.67a.898.898 0 01-.694-.327l-1.513-1.845H7.101zm2.687 9.99c-2.211 0-4.004-1.75-4.004-3.909 0-2.16 1.793-3.91 4.004-3.91 2.212 0 4.005 1.75 4.005 3.91s-1.793 3.91-4.005 3.91zm0-1.737c1.229 0 2.225-.972 2.225-2.172 0-1.2-.996-2.172-2.225-2.172-1.228 0-2.224.972-2.224 2.172 0 1.2.996 2.172 2.224 2.172z",
  fill: "#FFF",
  fillRule: "nonzero"
});

function SvgPhotoIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 15,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgPhotoIcon;